import { render, staticRenderFns } from "./countUp.vue?vue&type=template&id=b07aaa36&"
import script from "./countUp.vue?vue&type=script&lang=js&"
export * from "./countUp.vue?vue&type=script&lang=js&"
import style0 from "./countUp.vue?vue&type=style&index=0&id=b07aaa36&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports